import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS3() {
    window.scrollTo(0,0);
    return (
        <div className="container">
             <img src="/images/clrhs3.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS3
